var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/product-image.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["imageUrl", "imageStyle", "colorCode", "imageId"], 
["altImageId", "preset", "imageHeight", "imageWidth", "altText", "class", "disableZoom", "defaultImage", "fit", "lazyImage", "lazyImageWidth", "lazyImageHeight", "lazy", "quality"], 
function (l_imageUrl, l_imageStyle, l_colorCode, l_imageId, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("imageUrl", l_imageUrl);
frame.set("imageStyle", l_imageStyle);
frame.set("colorCode", l_colorCode);
frame.set("imageId", l_imageId);
frame.set("altImageId", kwargs.hasOwnProperty("altImageId") ? kwargs["altImageId"] : null);
frame.set("preset", kwargs.hasOwnProperty("preset") ? kwargs["preset"] : null);
frame.set("imageHeight", kwargs.hasOwnProperty("imageHeight") ? kwargs["imageHeight"] : null);
frame.set("imageWidth", kwargs.hasOwnProperty("imageWidth") ? kwargs["imageWidth"] : null);
frame.set("altText", kwargs.hasOwnProperty("altText") ? kwargs["altText"] : "");
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
frame.set("disableZoom", kwargs.hasOwnProperty("disableZoom") ? kwargs["disableZoom"] : false);
frame.set("defaultImage", kwargs.hasOwnProperty("defaultImage") ? kwargs["defaultImage"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("fit", kwargs.hasOwnProperty("fit") ? kwargs["fit"] : "&fit=constrain");
frame.set("lazyImage", kwargs.hasOwnProperty("lazyImage") ? kwargs["lazyImage"] : false);
frame.set("lazyImageWidth", kwargs.hasOwnProperty("lazyImageWidth") ? kwargs["lazyImageWidth"] : null);
frame.set("lazyImageHeight", kwargs.hasOwnProperty("lazyImageHeight") ? kwargs["lazyImageHeight"] : null);
frame.set("lazy", kwargs.hasOwnProperty("lazy") ? kwargs["lazy"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("quality", kwargs.hasOwnProperty("quality") ? kwargs["quality"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_2 = "";t_2 += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "defaultImage")) {
t_2 += "\n        ";
var t_3;
t_3 = runtime.contextOrFrameLookup(context, frame, "defaultImage");
frame.set("imageSlug", t_3, true);
if(frame.topLevel) {
context.setVariable("imageSlug", t_3);
}
if(frame.topLevel) {
context.addExport("imageSlug", t_3);
}
t_2 += "\n    ";
;
}
else {
t_2 += "\n        ";
var t_4;
t_4 = (lineno = 26, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "getSlug"), "getSlug", context, [l_imageStyle,l_colorCode,l_imageId]));
frame.set("imageSlug", t_4, true);
if(frame.topLevel) {
context.setVariable("imageSlug", t_4);
}
if(frame.topLevel) {
context.addExport("imageSlug", t_4);
}
t_2 += "\n    ";
;
}
t_2 += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "quality")) {
t_2 += "\n        ";
var t_5;
t_5 = "&qlt=" + "" + runtime.contextOrFrameLookup(context, frame, "quality");
frame.set("qlt", t_5, true);
if(frame.topLevel) {
context.setVariable("qlt", t_5);
}
if(frame.topLevel) {
context.addExport("qlt", t_5);
}
t_2 += "\n    ";
;
}
else {
t_2 += "\n        ";
var t_6;
t_6 = "";
frame.set("qlt", t_6, true);
if(frame.topLevel) {
context.setVariable("qlt", t_6);
}
if(frame.topLevel) {
context.addExport("qlt", t_6);
}
t_2 += "\n    ";
;
}
if(runtime.contextOrFrameLookup(context, frame, "preset") && runtime.contextOrFrameLookup(context, frame, "imageHeight") && runtime.contextOrFrameLookup(context, frame, "imageWidth")) {
var t_7;
t_7 = "?" + "" + runtime.contextOrFrameLookup(context, frame, "preset") + "" + "&hei=" + "" + runtime.contextOrFrameLookup(context, frame, "imageHeight") + "" + "&wid=" + "" + runtime.contextOrFrameLookup(context, frame, "imageWidth");
frame.set("sizePreset", t_7, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_7);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_7);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "preset") && runtime.contextOrFrameLookup(context, frame, "imageHeight")) {
var t_8;
t_8 = "?" + "" + runtime.contextOrFrameLookup(context, frame, "preset") + "" + "&hei=" + "" + runtime.contextOrFrameLookup(context, frame, "imageHeight");
frame.set("sizePreset", t_8, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_8);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_8);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "preset") && runtime.contextOrFrameLookup(context, frame, "imageWidth")) {
var t_9;
t_9 = "?" + "" + runtime.contextOrFrameLookup(context, frame, "preset") + "" + "&wid=" + "" + runtime.contextOrFrameLookup(context, frame, "imageWidth");
frame.set("sizePreset", t_9, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_9);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_9);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "preset")) {
var t_10;
t_10 = "?" + "" + runtime.contextOrFrameLookup(context, frame, "preset");
frame.set("sizePreset", t_10, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_10);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_10);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "imageHeight")) {
var t_11;
t_11 = "?hei=" + "" + runtime.contextOrFrameLookup(context, frame, "imageHeight");
frame.set("sizePreset", t_11, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_11);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_11);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "imageWidth")) {
var t_12;
t_12 = "?wid=" + "" + runtime.contextOrFrameLookup(context, frame, "imageWidth");
frame.set("sizePreset", t_12, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_12);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_12);
}
;
}
else {
var t_13;
t_13 = "";
frame.set("sizePreset", t_13, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_13);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_13);
}
;
}
;
}
;
}
;
}
;
}
;
}
t_2 += "<img\n        ";
if(!(lineno = 53, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.thirdParty.productImages",runtime.contextOrFrameLookup(context, frame, "True")]))) {
t_2 += "src=\"";
t_2 += runtime.suppressValue((lineno = 54, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.thirdParty.productImageSrc",""])), env.opts.autoescape);
t_2 += "\"\n            data-alt-src=\"";
t_2 += runtime.suppressValue((lineno = 55, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.thirdParty.productImageSrc",""])), env.opts.autoescape);
t_2 += "\"";
;
}
else {
t_2 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "lazy")) {
t_2 += " data-src=\"";
t_2 += runtime.suppressValue((lineno = 57, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "productImageSrc"), "productImageSrc", context, [l_imageUrl,runtime.contextOrFrameLookup(context, frame, "imageSlug")])), env.opts.autoescape);
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sizePreset"), env.opts.autoescape);
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "qlt"), env.opts.autoescape);
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fit"), env.opts.autoescape);
t_2 += "\"";
if(runtime.contextOrFrameLookup(context, frame, "lazyImage")) {
t_2 += " src=\"";
t_2 += runtime.suppressValue((lineno = 57, colno = 121, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "lazyPreload"), "lazyPreload", context, [l_imageUrl,runtime.contextOrFrameLookup(context, frame, "lazyImageWidth"),runtime.contextOrFrameLookup(context, frame, "lazyImageHeight")])), env.opts.autoescape);
t_2 += "\"";
;
}
t_2 += " ";
;
}
else {
t_2 += "\n        src=\"";
t_2 += runtime.suppressValue((lineno = 58, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "productImageSrc"), "productImageSrc", context, [l_imageUrl,runtime.contextOrFrameLookup(context, frame, "imageSlug")])), env.opts.autoescape);
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "sizePreset")), env.opts.autoescape);
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "qlt"), env.opts.autoescape);
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fit"), env.opts.autoescape);
t_2 += "\"";
;
}
if(runtime.contextOrFrameLookup(context, frame, "altImageId")) {
t_2 += " data-alt-src=\"";
t_2 += runtime.suppressValue((lineno = 59, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "productImageSrc"), "productImageSrc", context, [l_imageUrl,(lineno = 59, colno = 72, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "getSlug"), "getSlug", context, [l_imageStyle,l_colorCode,runtime.contextOrFrameLookup(context, frame, "altImageId")]))])), env.opts.autoescape);
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "sizePreset")), env.opts.autoescape);
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "qlt"), env.opts.autoescape);
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fit"), env.opts.autoescape);
t_2 += "\"";
;
}
;
}
t_2 += "alt=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "altText"), env.opts.autoescape);
t_2 += "\"\n        class=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "class"), env.opts.autoescape);
t_2 += " ";
if(runtime.contextOrFrameLookup(context, frame, "lazy")) {
t_2 += " js-lazy ";
;
}
if(!runtime.contextOrFrameLookup(context, frame, "disableZoom")) {
t_2 += " has-zoom js-zoom-product-image";
;
}
t_2 += "\"\n        data-qa-product-image\n    />\n";
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("productImage");
context.setVariable("productImage", macro_t_1);
var macro_t_14 = runtime.makeMacro(
["imageUrl", "imageSlug"], 
[], 
function (l_imageUrl, l_imageSlug, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("imageUrl", l_imageUrl);
frame.set("imageSlug", l_imageSlug);
var t_15 = "";t_15 += runtime.suppressValue(l_imageUrl + "" + l_imageSlug, env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_15);
});
context.addExport("productImageSrc");
context.setVariable("productImageSrc", macro_t_14);
var macro_t_16 = runtime.makeMacro(
["imageStyle", "colorCode", "imageId"], 
[], 
function (l_imageStyle, l_colorCode, l_imageId, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("imageStyle", l_imageStyle);
frame.set("colorCode", l_colorCode);
frame.set("imageId", l_imageId);
var t_17 = "";t_17 += runtime.suppressValue(l_imageStyle, env.opts.autoescape);
t_17 += "_";
t_17 += runtime.suppressValue(l_colorCode, env.opts.autoescape);
t_17 += "_";
t_17 += runtime.suppressValue(l_imageId, env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_17);
});
context.addExport("getSlug");
context.setVariable("getSlug", macro_t_16);
var macro_t_18 = runtime.makeMacro(
["imageUrl", "lazyImageWidth", "lazyImageHeight"], 
[], 
function (l_imageUrl, l_lazyImageWidth, l_lazyImageHeight, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("imageUrl", l_imageUrl);
frame.set("lazyImageWidth", l_lazyImageWidth);
frame.set("lazyImageHeight", l_lazyImageHeight);
var t_19 = "";t_19 += runtime.suppressValue(l_imageUrl, env.opts.autoescape);
t_19 += "loading-spacer?&fmt=png-alpha&wid=";
t_19 += runtime.suppressValue(l_lazyImageWidth, env.opts.autoescape);
t_19 += "&hei=";
t_19 += runtime.suppressValue(l_lazyImageHeight, env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_19);
});
context.addExport("lazyPreload");
context.setVariable("lazyPreload", macro_t_18);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/product-image.j2"] , dependencies)